export default {
	logo: {
		fontWeight: '700',
		textAlign: 'center',
		color: '#fff',
		verticalAlign: 'initial',
		height: '85px',
		margin: '15px',
		lineHeight: '37px',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		marginBottom: '50px',
		'& img': {
			height: '100%',
			cursor: 'pointer'
		}
	},
	sider: {
		position: 'fixed',
		// zIndex: '1019',
		// width: '200px',
		height: '100vh',
		overflow: 'auto'
	},
	menu: {
		// height: 'calc(100vh - 120px)'
	}
};
